const blogsLink =
  JSON.parse(localStorage.getItem("configs"))?.blogs?.config_value || ""

export const header = (courseTypes, instituteName, courses) => {
  return {
    headerLinks: [
      {
        id: 1,
        name: "Home",
        componentName: "FancyHome",
        hideForAlkuttab: false,
        icon: "mdi-home",
      },
      {
        id: 2,
        name: "Tutors",
        componentName: "Tutors",
        hideForAlkuttab: false,
        icon: "mdi-account-group",
      },
      {
        id: 3,
        name: "groups",
        componentName: "KidsCoursesList",
        hideForAlkuttab: false,
        icon: "mdi-school",
      },
      // {
      //   id: 6,
      //   name: "courses",
      //   componentName: "CoursesList",
      //   hideForAlkuttab: false,
      // subMenu: courseTypes?.options?.map(courseType => ({
      //   id: courseType.value,
      //   name: courseType.title,
      //   hasCategories: true,
      //   categories: courses
      //     .filter(course => course.course_type_id === courseType.value)
      //     .map(category => {
      //       return {
      //         id: category.id,
      //         name: category.title,
      //         componentName: "CourseTypeDetails",
      //       }
      //     }),
      // })),
      // },
      {
        id: 4,
        name: "joinFreeHalaqa",
        componentName: "Webinars",
        hideForAlkuttab: false,
        icon: "mdi-video",
      },
      {
        id: 5,
        name: "blogs",
        link: blogsLink,
        icon: "mdi-post",
      },
      {
        id: 7,
        name: "About",
        componentName: "About",
        hideForAlkuttab: true, // This will hide it for all institutes except id = 1
        icon: "mdi-information",
        // stop showing submenu for now
        // subMenu: [
        //   {
        //     id: 1,
        //     name: `About ${instituteName}`,
        //     componentName: "About",
        //   },
        // ],
      },
    ],
    header_menu: {
      student: [
        {
          id: 1,
          name: "profile",
          componentName: "Profile",
        },
        {
          id: 2,
          name: "classes",
          componentName: "BookedClasses",
        },
        {
          id: 3,
          name: "updateSettings",
          componentName: "UpdatePassword",
        },
        {
          id: 4,
          name: "subAccounts",
          componentName: "SubAccounts",
        },
      ],
      tutor: [
        {
          id: 1,
          name: "profile",
          componentName: "Profile",
        },
        {
          id: 2,
          name: "classes",
          componentName: "CurrentClasses",
        },
        {
          id: 3,
          name: "updateSettings",
          componentName: "UpdatePassword",
        },
      ],
      operator: [
        {
          id: 1,
          name: "dashboard",
          componentName: "ApprovedTutors",
        },
        {
          id: 2,
          name: "instituteManagement",
          componentName: "InstituteManagement",
        },
      ],
      institute_admin: [
        {
          id: 1,
          name: "dashboard",
          componentName: "ApprovedTutors",
        },
        {
          id: 2,
          name: "instituteManagement",
          componentName: "InstituteManagement",
        },
      ],
      kids: [
        {
          id: 1,
          name: "classes",
          componentName: "BookedClasses",
        },
      ],
    },
  }
}
